if (!customElements.get('sticky-header')) {
	customElements.define('sticky-header', class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.stickyDisabled = this.getAttribute('disabled') === 'true';
			this.header = document.querySelector('.section-header');
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => {
				this.preventReveal = true;
			};

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			// Tilpass hoyden pa handlekurven nar Safari viser eller skjuler adresselinjen.
			this.onResizeHandler = () => {
				const miniCart = this.header.querySelector('header-mini-cart-dropdown-modal[open]');
				if (miniCart && miniCart.setMaxHeight) {
					miniCart.setMaxHeight();
				}
			};
			window.addEventListener('resize', this.onResizeHandler);
			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', this.onResizeHandler);
			}

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
			window.removeEventListener('resize', this.onResizeHandler);
			if (window.visualViewport) {
				window.visualViewport.removeEventListener('resize', this.onResizeHandler);
			}
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.predictiveSearch && this.predictiveSearch.isOpen) {
				return;
			}

			// Pa mobil skal en apen handlekurv eller meny i toppen ikke lukkes av scroll.
			// Safari gir et lite scrollhopp nar adresselinjen vises eller skjules.
			if (window.innerWidth < 990 && this.header.querySelector('.dropdown-modal[open]')) {
				this.currentScrollTop = scrollTop;
				return;
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal && !this.stickyDisabled) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (!this.stickyDisabled && scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			} else if (this.stickyDisabled && scrollTop <= this.headerBounds.bottom) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			this.header.classList.add('section-header-hidden', 'section-header-sticky');

			// Add methods to close dropdowns etc
			this.closeHeaderDropdowns();
		}

		reveal() {
			this.header.classList.add('section-header-sticky', 'animate');
			this.header.classList.remove('section-header-hidden');
		}

		reset() {
			this.header.classList.remove('section-header-hidden', 'section-header-sticky', 'animate');
		}

		closeHeaderDropdowns() {
			const headerLocalizationDropdowns = this.header.querySelectorAll('localization-form')
			const headerDropdowns = this.header.querySelectorAll('.dropdown-modal');

			headerLocalizationDropdowns.forEach(dropdown => {
				dropdown.hidePanel();
			});
			headerDropdowns.forEach(dropdown => {
				dropdown.close();
			});
		}
	});
}
